// libraries.
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// apis
import { apiOrchestratorPricingCommittee } from '../../../../redux/apiSlices/apiSlices';

// interfaces.
import { ModelError } from '../../../../interfaces/interfaces';
import {
  IOrchestratorPricingCommitteeResponse,
  IOrchestratorPricingCommittee,
} from '../../interfaces/interfaces';

export type CountryCode = 'CO' | 'MX' | string;

export const orchestratorPricingCommittee =
  apiOrchestratorPricingCommittee.injectEndpoints({
    endpoints: builder => ({
      getCurrentOrchestrator: builder.query<
        IOrchestratorPricingCommittee,
        { country?: CountryCode; nid: string }
      >({
        query: params => ({
          url: `/retrieve-current-orchestrator`,
          params,
        }),
        transformErrorResponse: (error: FetchBaseQueryError) => {
          const modelError: ModelError = {
            errorStatus: error.status,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            messageFromServer: (error.data as any)?.message,
            serviceErrorName: 'getCurrentOrchestrator',
          };
          return modelError;
        },
        transformResponse: (
          response: IOrchestratorPricingCommitteeResponse
        ): IOrchestratorPricingCommittee => {
          return response.orchestrator;
        },
        providesTags: (result, error, { country, nid }) => [
          {
            type: 'CurrentOrchestrator' as const,
            id: `${country ?? 'all'}:${nid ?? 'current'}`,
          },
        ],
      }),
    }),
  });

export const { useGetCurrentOrchestratorQuery } = orchestratorPricingCommittee;
